import React, { useEffect, useState } from "react";
import { Modal, Button } from "reactstrap";
import ClipLoader from "react-spinners/ClipLoader";

import api from "../../../Api.js";

export default function RemoveClassRoomModal({
  isOpen,
  classroom,
  translate = {},
  notify,
  onClose,
  onRemoved,
}) {
  const [isRemoving, setIsRemoving] = useState(false);

  useEffect(() => {
    if (!isOpen && isRemoving) {
      setIsRemoving(false);
    }
  }, [isOpen, isRemoving]);

  const closeModal = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const emitRemoval = async (removedId) => {
    if (typeof onRemoved === "function") {
      await onRemoved(removedId);
    }
  };

  const sendNotification = (options) => {
    if (typeof notify === "function" && options) {
      notify(options);
    }
  };

  const handleRemove = async () => {
    if (!classroom?.id || isRemoving) {
      return;
    }

    setIsRemoving(true);

    try {
      await api.deleteClassRoom(classroom.id);

      sendNotification({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(translate["sucesso"] || "Sucesso") + "!"}
            </span>
            <span data-notify="message">
              {translate["a_turma_foi_removida"] || "A turma foi removida."}
            </span>
          </div>
        ),
        type: "success",
        icon: "ni ni-check-bold",
        autoDismiss: 7,
      });

      await emitRemoval(classroom.id);
      closeModal();
    } catch (error) {
      console.error("Erro ao remover turma", error);

      let message = translate["nao_foi_possivel_remover_turma"] ||
        "Não foi possível remover a turma.";

      if (error?.response?.data?.msg) {
        message = error.response.data.msg;
      }

      sendNotification({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(translate["ops"] || "Ops") + "!"}
            </span>
            <span data-notify="message">{message}</span>
          </div>
        ),
        type: "danger",
        icon: "fas fa-exclamation",
        autoDismiss: 7,
      });
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <Modal
      className="modal-dialog-centered modal-danger"
      contentClassName="bg-gradient-danger"
      isOpen={Boolean(isOpen)}
      toggle={closeModal}
    >
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-notification">
          {translate["sua_atencao_e_requirida"] || "Sua atenção é requerida"}
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={closeModal}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="py-3 text-center">
          <i
            className="fas fa-exclamation-triangle fa-x3"
            style={{ fontSize: "45px" }}
          ></i>
          <h4 className="heading mt-4">
            {(translate["voce_deve_ler_isto"] || "Você deve ler isto") + "!"}
          </h4>
          <p
            dangerouslySetInnerHTML={{
              __html:
                translate["atencao_remover_turma"] ||
                "Tem certeza que deseja remover esta turma?",
            }}
          ></p>
          {classroom?.name && (
            <p className="mt-3">
              <strong>{translate["turma"] || "Turma"}:</strong> {classroom.name}
            </p>
          )}
        </div>
      </div>
      <div className="modal-footer">
        <Button
          className="btn-white"
          color="default"
          type="button"
          onClick={handleRemove}
          disabled={isRemoving}
        >
          {isRemoving ? (
            <span className="d-inline-flex align-items-center">
              <ClipLoader size={14} color="#5e72e4" loading={true} className="mr-2" />
              {translate["removendo"] || "Removendo..."}
            </span>
          ) : (
            translate["ok_remova"] || "Ok, remova"
          )}
        </Button>
        <Button
          className="text-white ml-auto"
          color="link"
          data-dismiss="modal"
          type="button"
          onClick={closeModal}
          disabled={isRemoving}
        >
          {translate["cancelar_e_fechar"] || "Cancelar e fechar"}
        </Button>
      </div>
    </Modal>
  );
}
